module.exports = __webpack_public_path__ + "img/fail_icon.a23a1eb7.png";